import { ArrowLeft, ShoppingBag, ExternalLink, ClipboardCheck, CheckCircle, Bot, BookOpen } from 'lucide-react';
import { Link } from 'react-router-dom';

const Boutique = () => {
  return (
    <div className="min-h-screen bg-black text-white">
      {/* Hero Section */}
      <div className="bg-gradient-to-b from-[#C9A55C]/10 to-black py-16">
        <div className="container mx-auto px-4 max-w-6xl">
          {/* Back button */}
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-[#C9A55C] hover:text-[#C9A55C]/80 mb-8 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Retour à l'accueil
          </Link>

          <div className="text-center">
            <div className="inline-flex items-center gap-3 mb-6">
              <ShoppingBag className="w-10 h-10 text-[#C9A55C]" />
              <h1 className="text-4xl md:text-5xl font-serif font-bold">
                <span className="text-white">Notre</span>{' '}
                <span className="text-[#C9A55C]">Boutique</span>
              </h1>
            </div>
            <p className="text-white/60 text-lg max-w-2xl mx-auto">
              Pour particuliers et entrepreneurs
            </p>
          </div>
        </div>
      </div>

      {/* Catégorie : Agent IA */}
      <div className="py-16 border-t border-[#C9A55C]/20">
        <div className="container mx-auto px-4 max-w-6xl">
          <h2 className="text-2xl font-serif font-bold text-[#C9A55C] mb-8 flex items-center gap-3">
            <Bot className="w-6 h-6" />
            Agent IA
          </h2>
          
          <a
            href="https://zerux.helpadn.fr"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 px-10 py-5 bg-[#C9A55C] text-black hover:bg-[#C9A55C]/90 transition-colors text-xl font-bold tracking-wider uppercase"
            data-testid="boutique-agent-ia"
          >
            <ExternalLink className="w-6 h-6" />
            Accéder à l'Agent IA
          </a>
        </div>
      </div>

      {/* Catégorie : Guides Interactifs */}
      <div className="py-16 border-t border-[#C9A55C]/20">
        <div className="container mx-auto px-4 max-w-6xl">
          <h2 className="text-2xl font-serif font-bold text-[#C9A55C] mb-8 flex items-center gap-3">
            <BookOpen className="w-6 h-6" />
            Guides Interactifs
          </h2>
          
          <a
            href="https://helpadn.myshopify.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 px-10 py-5 bg-[#C9A55C] text-black hover:bg-[#C9A55C]/90 transition-colors text-xl font-bold tracking-wider uppercase"
            data-testid="boutique-guides-interactifs"
          >
            <ExternalLink className="w-6 h-6" />
            Voir les Guides
          </a>
        </div>
      </div>

      {/* Catégorie : Diagnostic */}
      <div className="py-16 border-t border-[#C9A55C]/20">
        <div className="container mx-auto px-4 max-w-6xl">
          <h2 className="text-2xl font-serif font-bold text-[#C9A55C] mb-8 flex items-center gap-3">
            <ClipboardCheck className="w-6 h-6" />
            Diagnostic
          </h2>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* Diagnostic PMR Card */}
            <div className="bg-black border-2 border-[#C9A55C]/30 p-8 lg:p-10 relative overflow-hidden">
              <div className="absolute top-0 right-0 bg-[#C9A55C] text-black px-4 py-1 text-xs font-bold tracking-wider">
                DIAGNOSTIC
              </div>
              <div className="mb-6 rounded overflow-hidden">
                <video controls className="w-full">
                  <source src="https://customer-assets-lqy194kg.emergentagent.net/job_service-devis-1/artifacts/zrbhin6s_65D3076E-FCE7-45A0-A99C-5D0358458DFF.mp4" type="video/mp4" />
                </video>
              </div>
              
              <h3 className="text-2xl font-serif font-bold text-white mb-2">
                Diagnostic <span className="text-[#C9A55C]">PMR</span>
              </h3>
              
              <div className="inline-flex items-center gap-2 bg-green-500/10 border border-green-500/30 px-3 py-1 text-xs text-green-400 mb-6">
                <CheckCircle className="w-3 h-3" />
                Disponible
              </div>
              
              <p className="text-white/70 mb-4 leading-relaxed font-semibold">
                La loi impose l'accessibilité handicap pour tous les commerces. En 2026, les contrôles sont renforcés.
              </p>
              
              <div className="space-y-2 mb-6">
                <div className="flex items-start gap-2 text-sm text-white/80">
                  <CheckCircle className="w-3 h-3 text-[#C9A55C] flex-shrink-0 mt-1" />
                  <span>Nous réalisons le diagnostic PMR de votre commerce.</span>
                </div>
                <div className="flex items-start gap-2 text-sm text-white/80">
                  <CheckCircle className="w-3 h-3 text-[#C9A55C] flex-shrink-0 mt-1" />
                  <span>Nous vérifions ce qui est conforme et ce qui ne l'est pas.</span>
                </div>
                <div className="flex items-start gap-2 text-sm text-white/80">
                  <CheckCircle className="w-3 h-3 text-[#C9A55C] flex-shrink-0 mt-1" />
                  <span>Nous examinons si une dérogation est possible.</span>
                </div>
                <div className="flex items-start gap-2 text-sm text-white/80">
                  <CheckCircle className="w-3 h-3 text-[#C9A55C] flex-shrink-0 mt-1" />
                  <span>Nous préparons votre attestation si nécessaire.</span>
                </div>
                <div className="flex items-start gap-2 text-sm text-white/80">
                  <CheckCircle className="w-3 h-3 text-[#C9A55C] flex-shrink-0 mt-1" />
                  <span>Nous établissons votre plan d'action en cas de non-conformité.</span>
                </div>
              </div>
              
              <p className="text-white/70 mb-3 leading-relaxed text-sm">
                Nous nous déplaçons pour un diagnostic complet avec toutes les mesures. Nous étudions votre dossier pour les aides possibles et les dérogations.
              </p>
              
              <p className="text-[#C9A55C] font-semibold mb-3 text-sm">
                Nous proposons des améliorations réalisables SANS gros travaux.
              </p>
              
              <p className="text-white/50 text-xs mb-6">
                Déplacement dans un rayon de 30 km autour de Lille.
              </p>
              
              <a
                href="/#contact"
                className="w-full bg-[#C9A55C] text-black hover:bg-[#C9A55C]/90 h-12 text-sm font-semibold tracking-wider uppercase flex items-center justify-center gap-2 transition-colors"
                data-testid="diagnostic-pmr-contact"
              >
                Demander un devis
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Boutique;
